import { FixMeLater, PrecisionConfig, PrecisionType } from "@shared/types";
import usePrecision from "@shared/common/Precision/usePrecision";
import { getLocaleStringWithPrecision } from "@shared/utils/numbers";

export type useTextWithPrecisionProps = {
  text?: string | number;
  precisionSelector?: (
    rootState: FixMeLater
  ) => PrecisionConfig | {} | undefined;
  precisionType?: PrecisionType;
  precisionCoin?: string;
  exchange?: string;
  precision?: number;
  precisionConfig?: PrecisionConfig;
  round?: boolean;
  withFallback?: boolean;
};

export const useTextWithPrecision = ({
  text,
  precisionSelector,
  precisionConfig,
  precisionType,
  precisionCoin,
  exchange,
  round = false,
  withFallback = false,
  precision,
}: useTextWithPrecisionProps) => {
  const { getPrecision } = usePrecision(precisionSelector, precisionConfig);

  const getValue = () => {
    if (text !== undefined && !isNaN(text as number)) return Number(text);
    return "";
  };

  const value = getValue();
  let localPrecision =
    precision || getPrecision(precisionType, precisionCoin, exchange) || 0;
  let valueWithPrecision = "";
  if (typeof value === "number") {
    valueWithPrecision = getLocaleStringWithPrecision(
      value,
      localPrecision,
      round,
      withFallback
    );
  }

  return valueWithPrecision;
};
